import urlConfig from "./urlConfig.js";

/**
 * Thrown when the refresh token is expired, revoked, or was issued by a different
 * OAuth client. Callers must send the user back through the Google consent flow —
 * retrying the refresh will never succeed.
 */
class ReauthRequiredError extends Error {
  constructor(message) {
    super(message);
    this.name = "ReauthRequiredError";
  }
}

const getToken = async () => {
  if (tokenExpired()) {
    const refreshtoken = sessionStorage.getItem("refreshToken");
    const token = await getValidTokenFromServer(refreshtoken);
    sessionStorage.setItem("accessToken", token.accessToken);
    sessionStorage.setItem("expirationDate", newExpirationDate());
    return token.accessToken;
  } else {
    console.log("tokens.js 11 | token not expired");
    return sessionStorage.getItem("accessToken");
  }
};

const newExpirationDate = () => {
  var expiration = new Date();
  expiration.setHours(expiration.getHours() + 1);
  return expiration;
};

const tokenExpired = () => {
  const now = Date.now();

  const expirationDate = sessionStorage.getItem("expirationDate");
  const expDate = new Date(expirationDate);

  if (now > expDate.getTime()) {
    return true; // token expired
  }

  return false; // valid token
};

const getValidTokenFromServer = async (refreshToken) => {
  // get new token from server with refresh token
  const env = urlConfig.getEnv(window.location.origin);
  const serverURL = urlConfig.serverURL(env);
  const googleApiBase =
    process.env.REACT_APP_GOOGLE_OAUTH_V2 === "1"
      ? `${serverURL}/api/google/v2`
      : `${serverURL}/api/google`;

  let request;
  try {
    request = await fetch(`${googleApiBase}/token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refreshToken: refreshToken,
      }),
    });
  } catch (error) {
    throw new Error(`Issue getting new token: ${error.message}`);
  }

  const token = await request.json().catch(() => ({}));

  if (!request.ok) {
    // The server sets reauthRequired on 400/401 (missing or rejected refresh token).
    // Clear the stale credentials so the app can't keep replaying them.
    if (token.reauthRequired) {
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("expirationDate");
      throw new ReauthRequiredError(
        token.errorDescription || "Google sign-in has expired.",
      );
    }
    throw new Error(
      `Issue getting new token: ${token.errorDescription || request.status}`,
    );
  }

  if (!token.accessToken) {
    throw new Error("Issue getting new token: no access token in response");
  }

  return token;
};

export { tokenExpired, getToken, ReauthRequiredError };
